import { INoteModel } from '../../../../../interfaces/INote';
import { IWeeklyRecapSectionProps } from './IWeeklyRecapSectionProps';
import { IZoneNoteModel } from '../../../../../interfaces/Report/ITimelineReport';
import { SectionFooter } from '../../SectionFooter';
import { SectionHeader } from '../../../collab-report/SectionHeader';
import { TimelineReportSections } from '../../../../../utilities/Constants';
import { ZoneNoteRows } from './ZoneNoteRows';

export interface IIndustryNewsSectionProps extends IWeeklyRecapSectionProps {
    data: IZoneNoteModel[];
    onNoteEdit: (e: React.FormEvent<HTMLButtonElement>, noteItem: INoteModel) => void;
    selectAllChecked: boolean;
}

export function IndustryNewsSection(props: IIndustryNewsSectionProps) {
    return (
        <div className="pb-2">
            <SectionHeader
                checked={props.checked}
                isPreviewMode={props.isPreviewMode}
                onCommentsButtonClick={props.onCommentsButtonClick}
                onSectionCheckedChange={props.onSectionCheckedChange}
                readonly={props.readonly}
                section={TimelineReportSections.ZoneNotes}
                title="Industry News"
            />

            <div className="margin-left-20">
                {props.data.length > 0 && (
                    <table className="table">
                        <thead>
                            <tr>
                                {!props.isPreviewMode && (
                                    <th style={{ width: 23 }}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="selectAll"
                                            checked={props.selectAllChecked}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                props.onSelectAllCheckedChanged(
                                                    e,
                                                    TimelineReportSections.ZoneNotes
                                                );
                                            }}
                                            disabled={props.readonly}
                                        />
                                    </th>
                                )}
                                <th>Topic</th>
                                <th>Source</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            <ZoneNoteRows
                                getCheckedValue={props.getCheckedValue}
                                zoneNotes={props.data}
                                previouslyViewedGuids={props.previouslyViewedGuids}
                                isPreviewMode={props.isPreviewMode}
                                isReadOnly={props.readonly}
                                user={props.user}
                                onCheckedChange={props.onCheckedChange}
                                onNoteEdit={props.onNoteEdit}
                            />
                        </tbody>
                    </table>
                )}
                <SectionFooter text={props.sectionComment} rowCount={props.data.length} />
            </div>
        </div>
    );
}
